import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IUpdateActiveKeyForTripSummaryActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/BookingDetailActionParams";

class UpdateActiveKeyForTripSummaryAction extends BaseAction<void, IUpdateActiveKeyForTripSummaryActionParams> {

    override async run(): Promise<void> {
        try {
            const { defaultActiveKey, legId, activeKeyDetails } = this.params!;            
            let defaultActiveKeyList = [...(defaultActiveKey || [])]
            const isNewActive = defaultActiveKeyList.find((d: any) => d?.legId === legId)
            if (!isNewActive) {
                defaultActiveKeyList.push({
                    activeKey: ["1"],
                    legId: legId
                })
            } else {
                defaultActiveKeyList = defaultActiveKey.map(({ ...d }: any) => {
                    if (d.legId === legId) {
                        d.activeKey = activeKeyDetails || []
                    }
                    return d
                })
            }            
            updateRecoilState("defaultActiveKeyForTripSummaryAtom", defaultActiveKeyList)
        } catch (error: any) {
            console.error("Error fetching Data:", error);
        }
    }
}

export const updateActiveKeyForTripSummaryAction = new UpdateActiveKeyForTripSummaryAction()